// extracted by mini-css-extract-plugin
export var footer = "_pk-5";
export var fulfillmentInput = "_pk-0";
export var shipDateInput = "_pk-1";
export var shipmentModal = "_pk-2";
export var shipmentModalContent = "_pk-3";
export var tableContainer = "_pk-4";